import type { SingleValue } from 'react-select';

import { StyledPlotSelect } from '../StyledPlotSelect';
import styles from './sankey-footer.module.css';

type NumOfNodesOption = {
  value: number;
  label: string;
};

type SankeyFooterProps = {
  numOfNodes: number;
  onNumOfNodesChange: (value: number) => void;
  options: number[];
};

export const SankeyFooter = ({
  numOfNodes,
  onNumOfNodesChange,
  options,
}: SankeyFooterProps) => {
  const numOfNodeOptions: NumOfNodesOption[] = options.map((value) => ({
    value,
    label: `${value}`,
  }));

  const numOfNodesValue: NumOfNodesOption = {
    value: numOfNodes,
    label: `${numOfNodes}`,
  };

  const onChange = (value: SingleValue<NumOfNodesOption>) => {
    if (value) {
      onNumOfNodesChange(value.value);
    }
  };

  return (
    <div
      className={styles.footer}
      data-html2canvas-ignore
      data-testid="sankey-node-count-select"
    >
      <StyledPlotSelect
        value={numOfNodesValue}
        onChange={onChange}
        options={numOfNodeOptions}
        menuPlacement="top"
        getOptionLabel={(option) => `Show ${option.label}`}
      />
    </div>
  );
};
